export default __webpack_public_path__ + "locales/pt-BR/People.json?hash=176eacf9bc0e739048fce3a2b8a6595e";